import dayjs from 'dayjs'
import { dateFormatType } from 'src/types/types'
import { KeyboardEvent } from 'react'
import axios from 'axios'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'

function setDateFormat(type: dateFormatType, timeData: number) {
  const formatType: { [key: string]: string } = {
    LOCATION_TIME: `HH:mm:ss A Z`,
    LOCATION_DATE: 'MMMM DD YYYY',
    LOCATION_DETAIL: 'MMMM DD YYYY, HH:mm:ss A Z',
    HOME: 'MMMM DD YYYY, HH:mm:ss A Z',
  }
  const formatDate = dayjs.unix(timeData).format(formatType[type])
  const DateSlice = (number: number) => formatDate.split(' ')[number]

  switch (type) {
    case 'LOCATION_TIME':
      return `${DateSlice(0)} ${DateSlice(1)} (UTC${DateSlice(2)?.charAt(0)}${Number(
        DateSlice(2)?.split(':')[0]?.replace('+', '')?.replace('-', ''),
      )})`
    case 'HOME':
      return `${DateSlice(0)} ${DateSlice(1)} ${DateSlice(2)?.replace(',', '')} ${DateSlice(
        3,
      )} ${DateSlice(4)} (UTC${DateSlice(5)?.charAt(0)}${Number(
        DateSlice(5)?.split(':')[0]?.replace('+', '')?.replace('-', ''),
      )})`
    case 'LOCATION_DETAIL':
      return !timeData
        ? ''
        : `${DateSlice(0)} ${DateSlice(1)} ${DateSlice(2)} ${DateSlice(3)} ${DateSlice(
            4,
          )} (UTC${DateSlice(5)?.charAt(0)}${Number(
            DateSlice(5)?.split(':')[0]?.replace('+', '')?.replace('-', ''),
          )})`
    default:
      return formatDate
  }
}

const Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

const handleEnterKeyDown = (e: KeyboardEvent<HTMLImageElement>, callBackFunc: () => void) => {
  if (e.key === 'Enter') {
    callBackFunc()
  }
}
// function replaceBrTag(str: string) {
//   return str.replace(/\n/gi, '<br />')
// }
const FCM_AUTHORIZATION = process.env.REACT_APP_FCM_AUTHORIZATION

async function fcmPushHandler(pushToken: string, pin: string) {
  try {
    return await axios.post(
      'https://fcm.googleapis.com/fcm/send',
      {
        priority: 'high',
        registration_ids: [pushToken],
        data: {
          Title: '서비스페이지_핀재설정',
          Contents: pin,
          PushType: '4000',
          TransID: SessionStorageUtils().getStorageData('RequestId'),
        },
      },
      { headers: { Authorization: `${FCM_AUTHORIZATION}` } },
    )
  } catch (error) {
    console.error(error)
  }
}

const DownloadsDefaultPath = '/storage/emulated/0/Download'
const InternalDefaultPath = '/storage/emulated/0'
const externalDefaultPath = '/storage/external_mfinder'

// pin 3자리 이상 연속된 숫자 사용 금지(예: 123, 234)
function hasThreeConsecutiveDigits(pin: string) {
  const digits = pin.split('').map((char) => parseInt(char))

  return digits.some((_, index, array) => {
    if (index < array.length - 2) {
      const consecutiveNumbers = [array[index], array[index + 1], array[index + 2]]
      return (
        (consecutiveNumbers[0] + 1 === consecutiveNumbers[1] &&
          consecutiveNumbers[1] + 1 === consecutiveNumbers[2]) ||
        (consecutiveNumbers[0] - 1 === consecutiveNumbers[1] &&
          consecutiveNumbers[1] - 1 === consecutiveNumbers[2])
      )
    }
    return false
  })
}

// 비밀번호에 3자리 이상 연속된 동일한 문자(예:111, 333)
function hasThreeIdenticalDigits(pin: string) {
  const regex = /(.)\1\1/ // 정규 표현식: 어떤 문자가 3번 연속으로 반복되는 경우
  return regex.test(pin)
}

function OpenExternalPage(url: string) {
  window.open(url, '_blank')
}

export const getRequestID = () => {
  const createGuid = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return `${createGuid()}${createGuid()}-${createGuid()}-${createGuid()}-${createGuid()}-${createGuid()}${createGuid()}${createGuid()}`
}

export const formatCountryName = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '_')
    .replace(/_+$/, '')
}

export const commonUtils = {
  Timezone,
  setDateFormat,
  OpenExternalPage,
  hasThreeConsecutiveDigits,
  hasThreeIdenticalDigits,
  handleEnterKeyDown,
  fcmPushHandler,
  DownloadsDefaultPath,
  externalDefaultPath,
  getRequestID,
  InternalDefaultPath,
  formatCountryName,
}
